export default ['$q', 'JsonRPCService', 'qnb.ErrorHandlingService', 'addressSettings', 'addresslookup.AddressSearchUtil', function ($q, JsonRPCService, ErrorHandlingService, addressSettings, AddressSearchUtil) {
    return {
        getOccupations: function getOccupations() {
            var deferred = $q.defer();
            JsonRPCService.send('guidance', 'guidance', 'getOccupations', []).then(function (response) {
                ErrorHandlingService.checkSessionUUID(response, deferred);
                deferred.resolve(response);
            }, function (error, status, headers) {
                deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        getQuestions: function getQuestions(model) {
            var deferred = $q.defer();
            JsonRPCService.send('guidance', 'guidance', 'populateQuestions', [model.value]).then(function (response) {
                ErrorHandlingService.checkSessionUUID(response, deferred);
                model.value = response;
                deferred.resolve(model);
            }, function (error, status, headers) {
                deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        getRecommendations: function getRecommendations(model) {
            var deferred = $q.defer();
            JsonRPCService.send('guidance', 'guidance', 'populateRecommendedProducts', [model.value]).then(function (response) {
                ErrorHandlingService.checkSessionUUID(response, deferred);
                model.value = response;
                deferred.resolve(model);
            }, function (error, status, headers) {
                deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        createAccountAndSubmission: function createAccountAndSubmission(model, productCode) {
            var deferred = $q.defer();
            JsonRPCService.send('guidance', 'guidance', 'createAccountAndSubmission', [model.value, productCode.code.value]).then(function (response) {
                ErrorHandlingService.checkSessionUUID(response, deferred);
                deferred.resolve(response);
            }, function (error, status, headers) {
                deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        getAccountContactSummary: function getAccountContactSummary(accountNumber) {
            var deferred = $q.defer();
            JsonRPCService.send('guidance', 'guidance', 'getAccountContactSummary', [accountNumber]).then(function (response) {
                ErrorHandlingService.checkSessionUUID(response, deferred);
                return deferred.resolve(response);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        findAddress: function findAddress(addressString) {
            return AddressSearchUtil.lookupAddress(addressString, addressSettings);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/services/GuidanceService.js
// module id = 963
// module chunks = 0